import { css } from '@emotion/react';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { IconButton, Text } from '@frontend/design-system';

export type ConfigCardProps = {
  title: string;
  onEdit?: () => void;
  children: React.ReactNode;
};

const styles = {
  card: css`
    padding: ${theme.spacing(3)};
    background-color: ${theme.colors.white};
    border-radius: ${theme.borderRadius.medium};
    border: 1px solid ${theme.colors.neutral20};
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(2)};
  `,
  header: css`
    display: flex;
    align-items: center;
    justify-content: space-between;
  `,
};

export function ConfigCard({ title, onEdit, children }: ConfigCardProps) {
  return (
    <div css={styles.card}>
      <div css={styles.header}>
        <Text weight='bold' size='large'>
          {title}
        </Text>
        {onEdit && (
          <IconButton label={`Edit ${title}`} onClick={onEdit} size='small'>
            <Icon name='edit' size={16} color='subdued' />
          </IconButton>
        )}
      </div>
      <div>{children}</div>
    </div>
  );
}
